export default (state = {}, action) => {
  switch (action.type) {
    case 'GAME_DEVELOPERS_FETCH_SUCCESS':
      return {
        ...state,
        gameDevelopers: action.gameDevelopers
      };
    default:
      return state;
  }
}


/** WEBPACK FOOTER **
 ** ./src/reducers/gameDevelopersReducers.js
 **/